import { ROLE_LABELS } from '@kominiarz/shared';
import { LogOut } from 'lucide-react';
import { SECONDARY_NAV } from '../app/navigation';
import { useCurrentUser, useLogout } from '../auth/useAuth';
import { Avatar } from '../components/Avatar';
import { ActionRow, List } from '../components/List';
import { PageBody } from '../components/PageBody';
import { PageHeader } from '../components/PageHeader';
import styles from './MorePage.module.css';

export function MorePage() {
  const user = useCurrentUser();
  const logout = useLogout();
  const items = SECONDARY_NAV.filter((item) => !item.adminOnly || user.role === 'admin');

  return (
    <>
      <PageHeader title="Więcej" />
      <PageBody>
        <div className={styles.profile}>
          <Avatar name={user.name} color={user.color} size="lg" />
          <span className={styles.profileText}>
            <span className={styles.userName}>{user.name}</span>
            <span className={styles.userRole}>{ROLE_LABELS[user.role]}</span>
          </span>
        </div>
        <List standalone label="Więcej">
          {items.map(({ to, label, icon }) => (
            <ActionRow key={to} icon={icon} to={to}>
              {label}
            </ActionRow>
          ))}
        </List>
        <List standalone>
          <ActionRow icon={LogOut} onClick={() => logout.mutate()}>
            Wyloguj się
          </ActionRow>
        </List>
      </PageBody>
    </>
  );
}
